import {
  useSearches,
  getKey as getSearchesKey,
  ISearchKeyProps,
} from './useSearches';

const params: ISearchKeyProps = { active: true, depth: 'individual' };

export function getKey() {
  return getSearchesKey(params);
}

export function useMyActiveSearchesCount() {
  const { data, ...rest } = useSearches(params);

  const result = data?.count;

  return {
    ...rest,
    data: result,
  };
}
